export const MeControlCoreOriginator = "MeControlCore";
export const MeControlMeAccountOriginator = "MeControlMeAccount";
export const MeControlMTMAOriginator = "MeControlMTMA";
export const MeControlEventTypes = {
    openMeControl: "openMeControl",
    openProfileCard: "openProfileCard",
    pictureLoadFailed: "pictureLoadFailed",
    signIn: "signIn",
    signOut: "signOut",
    openMyAccount: "openMyAccount",
    updateProfilePicture: "updateProfilePicture",
    updateDisplayName: "updateDisplayName",
    customCommandClicked: "customCommandClicked",
    setAvailabilitySubmitted: "setAvailabilitySubmitted",
    setWorkLocationSubmitted: "setWorkLocationSubmitted",
    setStatusMessageSubmitted: "setStatusMessageSubmitted",
    scheduleOOF: "scheduleOOF",
    switchTenant: "switchTenant",
    switchAccount: "switchAccount",
    addNewAccount: "addNewAccount",
    signOutAndForget: "signOutAndForget",
    queryFailed: "queryFailed",
    renderFailed: "renderFailed",
};
export const events = {
    openMeControl: () => ({
        originator: MeControlCoreOriginator,
        type: MeControlEventTypes.openMeControl,
    }),
    openProfileCard: (data) => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.openProfileCard,
        data,
    }),
    pictureLoadFailed: (data) => ({
        originator: MeControlCoreOriginator,
        type: MeControlEventTypes.pictureLoadFailed,
        data,
    }),
    signIn: () => ({
        originator: MeControlCoreOriginator,
        type: MeControlEventTypes.signIn,
    }),
    signOut: () => ({
        originator: MeControlCoreOriginator,
        type: MeControlEventTypes.signOut,
    }),
    queryFailed: (data) => ({
        originator: MeControlCoreOriginator,
        type: MeControlEventTypes.queryFailed,
        data,
    }),
    renderFailed: (data) => ({
        originator: MeControlCoreOriginator,
        type: MeControlEventTypes.renderFailed,
        data,
    }),
    openMyAccount: () => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.openMyAccount,
    }),
    updateProfilePicture: (data) => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.updateProfilePicture,
        data,
    }),
    updateDisplayName: (data) => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.updateDisplayName,
        data,
    }),
    clickedCustomCommand: (data) => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.customCommandClicked,
        data,
    }),
    setAvailabilitySubmitted: (data) => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.setAvailabilitySubmitted,
        data,
    }),
    setWorkLocationSubmitted: (data) => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.setWorkLocationSubmitted,
        data,
    }),
    setStatusMessageSubmitted: (data) => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.setStatusMessageSubmitted,
        data,
    }),
    scheduleOOF: () => ({
        originator: MeControlMeAccountOriginator,
        type: MeControlEventTypes.scheduleOOF,
    }),
    switchTenant: (data) => ({
        originator: MeControlMTMAOriginator,
        type: MeControlEventTypes.switchTenant,
        data,
    }),
    switchAccount: (data) => ({
        originator: MeControlMTMAOriginator,
        type: MeControlEventTypes.switchAccount,
        data,
    }),
    addNewAccount: () => ({
        originator: MeControlMTMAOriginator,
        type: MeControlEventTypes.addNewAccount,
    }),
    signOutAndForget: (data) => ({
        originator: MeControlMTMAOriginator,
        type: MeControlEventTypes.signOutAndForget,
        data,
    }),
};
